<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    titulo: {
        type: String,
    },
    descricao: {
        type: String,
    },
    disabled: {
        type: Boolean,
        default: false
    },
    erro: {
        type: String,
        default: ''
    }
})

const emit = defineEmits(['update:modelValue', 'change']);

const modelValue = ref(props.modelValue);

// Só emite quando a mudança vem do usuário, não ao refletir um valor definido pelo pai.
watch(modelValue, (newValue) => {
    if (newValue === props.modelValue) return;
    emit('update:modelValue', newValue);
    emit('change', newValue);
});

// Mantém o switch sincronizado quando o valor é definido depois da montagem,
// como no preenchimento do formulário em telas de edição.
watch(() => props.modelValue, (novoValor) => {
    modelValue.value = novoValor;
});

</script>

<template>
    <div class="field mb-2 col-12">
        <div class="mb-2 border-1 border-round-2xl flex flex-column xl:flex-row gap-3 justify-content-between px-5 py-5"
            :class="erro ? 'border-red-400 bg-red-50' : 'border-300'">
            <div class="flex flex-column gap-2">
                <label for="objeto" class="text-md font-semibold m-0 max-w-16rem"
                    :class="erro ? 'text-red-600' : 'text-900'">{{ titulo }}</label>
                <span class="text-xs max-w-16rem" :class="erro ? 'text-red-500' : 'text-500'">{{ descricao }}</span>
            </div>
            <InputSwitch v-model="modelValue" :disabled="disabled" class="width: 4rem;" :pt="{
                style: { width: '3.2rem' },
                inputswitch: { style: 'width: 4rem !important;' },
                slider: {
                    class: modelValue ? 'bg-green-400' : (erro ? 'bg-red-200' : ''),
                    style: { width: '3.2rem' }
                }
            }" />
        </div>
        <div v-if="erro" class="flex align-items-center gap-2 px-1">
            <i class="pi pi-exclamation-circle p-error text-xs" />
            <SmallError :error="erro" />
        </div>
    </div>
</template>
